// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueLocalStorage from 'vue-ls'
import firebase from 'firebase'
import VueFire from 'vuefire'
import App from './App'
import { i18n } from './lang'
import router, { UserStore } from './router'
import toastr from 'toastr'
import ZyDialog from 'vue-zydialog'
import VueCroppie from 'vue-croppie'
import Vue2Filters from 'vue2-filters'
import moment from 'moment'
import numeral from 'numeral'
import VeeValidate from 'vee-validate'
import VueResource from 'vue-resource'

// app config as a plug-in app
var AppConfig = {}
AppConfig.install = function (_Vue, options) {
  var _APP_CONFIG = {
    api: {
      domain: process.env.API_URL,
      admin: {}
    }
  }

  _APP_CONFIG.api.login = () => { return `${_APP_CONFIG.api.domain}/api/v1/users/web/signin` }
  _APP_CONFIG.api.logout = () => { return `${_APP_CONFIG.api.domain}/auth/logout` }
  _APP_CONFIG.api.userinfo = () => { return `${_APP_CONFIG.api.domain}/api/v1/users/me` }

  // doctor api
  _APP_CONFIG.api.specialties = () => { return `${_APP_CONFIG.api.domain}/api/v1/specialties` }
  _APP_CONFIG.api.sub_specialities = (specialityId) => { return `${_APP_CONFIG.api.domain}/api/v1/subspecialties?speciality_id=${specialityId}` }
  _APP_CONFIG.api.institutes = () => { return `${_APP_CONFIG.api.domain}/api/v1/institutes` }
  _APP_CONFIG.api.languages = () => { return `${_APP_CONFIG.api.domain}/api/v1/languages` }
  _APP_CONFIG.api.provinces = () => { return `${_APP_CONFIG.api.domain}/api/v1/provinces` }
  _APP_CONFIG.api.districts = () => { return `${_APP_CONFIG.api.domain}/api/v1/districts` }
  _APP_CONFIG.api.config = () => { return `${_APP_CONFIG.api.domain}/api/v1/config` }

  // clinic api
  _APP_CONFIG.api.clinics = () => { return `${_APP_CONFIG.api.domain}/api/v1/clinics` }

  // Appointment
  _APP_CONFIG.api.appointments = () => { return `${_APP_CONFIG.api.domain}/api/v1/appointments/list` }
  _APP_CONFIG.api.appointment = () => { return `${_APP_CONFIG.api.domain}/api/v1/appointments` }
  _APP_CONFIG.api.appointment_id = (id) => { return `${_APP_CONFIG.api.domain}/api/v1/appointments/${id}` }
  _APP_CONFIG.api.appointmentsExport = () => { return `${_APP_CONFIG.api.domain}/export/appointments` }
  _APP_CONFIG.api.appointmentsExportFields = () => { return `${_APP_CONFIG.api.domain}/export/allfields` }
  _APP_CONFIG.api.appointment_patient = () => { return `${_APP_CONFIG.api.domain}/api/v1/appointments/patient` }

  // Inurance
  _APP_CONFIG.api.insurance = () => { return `${_APP_CONFIG.api.domain}/api/v1/insurances` }

  // Admin -> Doctor api
  _APP_CONFIG.api.admin.domain = () => { return `${_APP_CONFIG.api.domain}/admin/api/v1` }
  _APP_CONFIG.api.admin.doctors = () => { return `${_APP_CONFIG.api.admin.domain()}/doctors` }
  _APP_CONFIG.api.admin.doctors_id = (id) => { return `${_APP_CONFIG.api.admin.domain()}/doctors/${id}` }
  _APP_CONFIG.api.admin.doctors_clinic = (clinicId) => { return `${_APP_CONFIG.api.admin.domain()}/doctors?clinic_id=${clinicId}` }
  _APP_CONFIG.api.admin.doctorme = () => { return `${_APP_CONFIG.api.admin.domain()}/doctors/me` }
  _APP_CONFIG.api.admin.remove_image = (id) => { return `${_APP_CONFIG.api.admin.domain()}/me/image/${id}` }
  _APP_CONFIG.api.admin.upload_doctorme_image = (id) => { return `${_APP_CONFIG.api.admin.domain()}/doctors/${id}/image?is_active=1` }
  _APP_CONFIG.api.admin.upload_doctorme_alblum = (id) => { return `${_APP_CONFIG.api.admin.domain()}/doctors/${id}/image` }
  _APP_CONFIG.api.admin.doctor_stats = (id) => { return `${_APP_CONFIG.api.admin.domain()}/doctors/${id}/stats` }

  // Admin -> Clinic api
  _APP_CONFIG.api.admin.clinics = () => { return `${_APP_CONFIG.api.admin.domain()}/clinics` }
  _APP_CONFIG.api.admin.clinic_stats = (id) => { return `${_APP_CONFIG.api.admin.domain()}/clinics/${id}/stats` }
  _APP_CONFIG.api.admin.clinicme = (route, user) => {
    let url = `${_APP_CONFIG.api.admin.domain()}/clinics/me`
    // Multiple Clinic User
    if (route !== undefined && user !== undefined &&
    route.query.ref_clinic_id && user.isClinicMulti()) {
      url = `${_APP_CONFIG.api.admin.domain()}/clinics/${route.query.ref_clinic_id}`
    }
    return url
  }
  _APP_CONFIG.api.admin.upload_clinicme_image = () => { return `${_APP_CONFIG.api.admin.domain()}/clinics/me/image?is_active=1` }
  _APP_CONFIG.api.admin.upload_clinicme_alblum = () => { return `${_APP_CONFIG.api.admin.domain()}/clinics/me/image` }
  _APP_CONFIG.api.admin.upload_clinicme_alblum_id = (id) => { return `${_APP_CONFIG.api.admin.domain()}/clinics/me/image/${id}` }
  _APP_CONFIG.api.admin.clinic_services_id = (id) => { return `${_APP_CONFIG.api.admin.domain()}/clinics/services/${id}` }
  _APP_CONFIG.api.admin.clinicme_services = (route, user) => {
    let url = `${_APP_CONFIG.api.admin.domain()}/clinics/me/services`
    // Multiple Clinic User
    if (route !== undefined && user !== undefined &&
    route.query.ref_clinic_id && user.isClinicMulti()) {
      url = `${_APP_CONFIG.api.admin.domain()}/clinics/${route.query.ref_clinic_id}/services`
    }
    return url
  }
  _APP_CONFIG.api.admin.clinicme_services_id = (id, route, user) => {
    let url = `${_APP_CONFIG.api.admin.domain()}/clinics/me/services/${id}`
    // Multiple Clinic User
    if (route !== undefined && user !== undefined &&
    route.query.ref_clinic_id && user.isClinicMulti()) {
      url = `${_APP_CONFIG.api.admin.domain()}/clinics/${route.query.ref_clinic_id}/services/${id}`
    }

    return url
  }

  // Admin -> Patient
  _APP_CONFIG.api.admin.patient = (route, user) => { return `${_APP_CONFIG.api.admin.domain()}/ehr_patient` }
  _APP_CONFIG.api.admin.patient_id = (id) => { return `${_APP_CONFIG.api.admin.domain()}/ehr_patient/${id}` } // ehr_patient?clinic_id=114

  // Admin -> Article
  _APP_CONFIG.api.admin.articles = () => { return `${_APP_CONFIG.api.admin.domain()}/articles` }
  _APP_CONFIG.api.admin.articles_id = (id) => { return `${_APP_CONFIG.api.admin.domain()}/articles/${id}` } // articles/:article_id

  // Admin -> Appointment
  _APP_CONFIG.api.admin.appointment = () => { return `${_APP_CONFIG.api.admin.domain()}/appointments` }
  _APP_CONFIG.api.admin.appointment_id = (id) => { return `${_APP_CONFIG.api.admin.appointment()}/${id}` }
  _APP_CONFIG.api.admin.appointment_action = (id, action) => { return `${_APP_CONFIG.api.admin.appointment_id(id)}/${action}` }
  _APP_CONFIG.api.admin.appointment_status = () => { return `${_APP_CONFIG.api.admin.appointment()}/all_status` }

  // Review
  _APP_CONFIG.api.admin.reviews = () => { return `${_APP_CONFIG.api.admin.domain()}/reviews` }

  // Timeoff
  _APP_CONFIG.api.admin.timeoffs = () => { return `${_APP_CONFIG.api.admin.domain()}/timeoffs` }

  // Payment and subscription
  _APP_CONFIG.api.admin.payment_token = () => { return `${_APP_CONFIG.api.admin.domain()}/users/payment_token` }
  _APP_CONFIG.api.admin.subscription = () => { return `${_APP_CONFIG.api.admin.domain()}/doctors/me/subscribe` }

  // SMS broadcast
  _APP_CONFIG.api.admin.broadcast = () => { return `${_APP_CONFIG.api.admin.domain()}/broadcast` }
  _APP_CONFIG.api.admin.broadcast_check = () => { return `${_APP_CONFIG.api.admin.domain()}/broadcast/check` }

  _Vue.prototype.$APP_CONFIG = _APP_CONFIG
}

var AppUtils = {}
AppUtils.install = function (_Vue, options) {
  let ismobile = () => {
    if (navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i)) {
      return true
    } else {
      return false
    }
  }

  let loadFile = (f, callback) => {
    // Check for the various File API support.
    if (File && FileReader && FileList && Blob) {
      // Great success! All the File APIs are supported.

      var reader = new FileReader()
      // Closure to capture the file information.
      reader.onload = () => {
        callback(reader.result)
      }

      // Read in the image file as a data URL.
      reader.readAsDataURL(f)
    } else {
      console.log('The File APIs are not fully supported in this browser.')
    }
  }

  let b64toBlob = (b64Data, contentType, sliceSize) => {
    contentType = contentType || ''
    sliceSize = sliceSize || 512

    var byteCharacters = atob(b64Data)
    var byteArrays = []

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize)

      var byteNumbers = new Array(slice.length)
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i)
      }

      var byteArray = new Uint8Array(byteNumbers)

      byteArrays.push(byteArray)
    }

    var blob = new Blob(byteArrays, {type: contentType})
    return blob
  }

  var processB64ToBlob = (data) => {
    // Split the base64 string in data and contentType
    var block = data.split(';')
    // Get the content type of the image
    var contentType = block[0].split(':')[1] // In this case 'image/gif'
    // get the real base64 content of the file
    var realData = block[1].split(',')[1] // In this case 'R0lGODlhPQBEAPeoAJosM....'
    return b64toBlob(realData, contentType)
  }

  var formatDateTimeFull = (dateString) => {
    if (dateString) {
      return moment(dateString, 'YYYY-MM-DD HH:mm:ss').format('DD MMM YYYY HH:mm')
    }
    return ''
  }

  var formatDateFull = (dateString) => {
    if (dateString) {
      return moment(dateString, 'YYYY-MM-DD HH:mm:ss').format('DD MMM YYYY')
    }
    return ''
  }

  var formatTimeFull = (dateString) => {
    if (dateString) {
      return moment(dateString, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')
    }
    return ''
  }

  _Vue.prototype.$ismobile = ismobile
  _Vue.prototype.$loadFile = loadFile
  _Vue.prototype.$b64toBlob = b64toBlob
  _Vue.prototype.$processB64ToBlob = processB64ToBlob
  _Vue.filter('formatDateTimeFull', formatDateTimeFull)
  _Vue.filter('formatDateFull', formatDateFull)
  _Vue.filter('formatTimeFull', formatTimeFull)
}

// Initialize Firebase
var RealtimeDb = {}
RealtimeDb.install = function (_Vue, options) {
  var firebaseApp = firebase.initializeApp(process.env.FIREBASE_CONFIG)
  firebaseApp.auth().signInAnonymously()

  var db = firebaseApp.database()
  _Vue.prototype.$firebaseApp = firebaseApp
  _Vue.prototype.$rtdb = db
}

// Toast
var Toastr = {}
Toastr.install = function (_Vue, options) {
  _Vue.prototype.$toastr = toastr
}

// Language
Vue.use(VueLocalStorage, {namespace: 'app_zeekdoc__'})
i18n.locale = Vue.ls.get('lang', 'th')

UserStore.changeLang = (lang) => {
  i18n.locale = lang
}

Vue.use(AppConfig)
Vue.use(VueFire)
Vue.use(RealtimeDb)
Vue.use(AppUtils)
Vue.use(UserStore)
Vue.use(Vue2Filters)
Vue.use(Toastr)
Vue.use(VueCroppie)
Vue.use(ZyDialog, { lbLabel: i18n.t('action_message.cancel'), rbLabel: i18n.t('action_message.ok') })
Vue.use(VeeValidate)
Vue.use(VueResource)

// send credentials every request
Vue.http.options.credentials = true
Vue.http.headers.common['content-type'] = 'application/json'

// Interceptor
Vue.http.interceptors.push((request, next) => {
  if (request.method === 'GET') {
    // Add translate param
    request.params = Object.assign({}, request.params, {
      translate: i18n.locale
    })
  }
  next()
})

Vue.filter('formatNumber', function (value) {
  return numeral(value).format('0,0')
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js